(function () {
  var config = window.LegendCartDrawerConfig || {};
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  var closeButtons = document.querySelectorAll('[data-cart-drawer-close]');
  var cartTriggers = document.querySelectorAll('[data-cart-drawer-trigger]');
  var countBadges = document.querySelectorAll('[data-cart-count]');
  var statusNode = document.querySelector('[data-cart-drawer-status]');
  var emptyNode = document.querySelector('[data-cart-drawer-empty]');
  var linesNode = document.querySelector('[data-cart-drawer-lines]');
  var drawerCountNode = document.querySelector('[data-cart-drawer-count]');
  var subtotalNode = document.querySelector('[data-cart-drawer-subtotal]');
  var checkoutLink = document.querySelector('[data-cart-drawer-checkout]');
  var viewCartLink = document.querySelector('[data-cart-drawer-view-cart]');
  var activeElementBeforeOpen = null;

  if (!drawer || !overlay) return;

  function money(cents) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(config.locale || 'en-US', {
        style: 'currency',
        currency: config.currency || 'USD'
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function setStatus(message, isError) {
    if (!statusNode) return;
    statusNode.textContent = message || '';
    statusNode.classList.toggle('is-error', Boolean(isError));
  }

  function setCount(count) {
    countBadges.forEach(function (badge) {
      badge.textContent = String(count || 0);
    });
    document.querySelectorAll('.header-cart-link').forEach(function (link) {
      var label = (count || 0) === 1 ? 'Open cart, 1 item' : 'Open cart, ' + (count || 0) + ' items';
      link.setAttribute('aria-label', label);
    });
  }

  function focusDrawer() {
    var focusTarget = drawer.querySelector('[data-cart-drawer-close]') || drawer.querySelector('a, button');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  function openDrawer() {
    activeElementBeforeOpen = document.activeElement;
    overlay.hidden = false;
    document.body.classList.add('cart-drawer-is-open');
    drawer.setAttribute('aria-hidden', 'false');
    window.setTimeout(focusDrawer, 30);
  }

  function closeDrawer() {
    document.body.classList.remove('cart-drawer-is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    if (activeElementBeforeOpen && typeof activeElementBeforeOpen.focus === 'function') {
      activeElementBeforeOpen.focus({ preventScroll: true });
    }
  }

  function itemUrl(item) {
    return item.url || (item.handle ? '/products/' + item.handle : config.cartUrl || '/cart');
  }

  function cartThumbnailAsset(item) {
    var assets = config.cartThumbnailAssets || {};
    var handle = String(item && item.handle || '').toLowerCase();
    var title = String(item && (item.product_title || item.title) || '').toLowerCase();
    var haystack = handle + ' ' + title;

    if (haystack.indexOf('sweet-chili') !== -1 || haystack.indexOf('sweet chili') !== -1) return assets.sweetChili;
    if (haystack.indexOf('wings-sauce') !== -1 || haystack.indexOf('wings sauce') !== -1) return assets.wingsSauce;
    if (haystack.indexOf('pepper-shrimp') !== -1 || haystack.indexOf('pepper shrimp') !== -1) return assets.pepperShrimp;
    if (haystack.indexOf('fried-rice') !== -1 || haystack.indexOf('fried rice') !== -1) return assets.friedRice;
    if (haystack.indexOf('teriyaki') !== -1) return assets.teriyaki;
    if (haystack.indexOf('bbq') !== -1 || haystack.indexOf('barbecue') !== -1) return assets.caribbeanBbq;
    if (haystack.indexOf('hot-pepper') !== -1 || haystack.indexOf('hot pepper') !== -1) return assets.hotPepper;
    if (haystack.indexOf('lo-mein') !== -1 || haystack.indexOf('chow-mein') !== -1 || haystack.indexOf('lo mein') !== -1 || haystack.indexOf('chow mein') !== -1) return assets.loMeinChowMein;
    return '';
  }

  function appendText(parent, text) {
    parent.appendChild(document.createTextNode(text));
  }

  function renderLine(item) {
    var line = document.createElement('article');
    var media = document.createElement('a');
    var copy = document.createElement('div');
    var title = document.createElement('h3');
    var titleLink = document.createElement('a');
    var quantity = document.createElement('p');
    var casePrice = document.createElement('p');
    var lineTotal = document.createElement('p');
    var strong;

    line.className = 'cart-drawer-line';
    line.setAttribute('data-cart-drawer-line', '');
    media.className = 'cart-drawer-line-media';
    media.href = itemUrl(item);
    media.setAttribute('aria-label', 'View ' + (item.product_title || item.title || 'cart item'));
    var thumbnailSrc = cartThumbnailAsset(item) || item.image;
    if (thumbnailSrc) {
      var img = document.createElement('img');
      img.className = 'cart-drawer-line-image';
      img.src = thumbnailSrc;
      img.alt = item.product_title || item.title || 'Cart item';
      img.loading = 'lazy';
      media.appendChild(img);
    } else {
      media.textContent = 'LC';
    }

    copy.className = 'cart-drawer-line-copy';
    titleLink.href = itemUrl(item);
    titleLink.textContent = item.product_title || item.title || 'Cart item';
    title.appendChild(titleLink);
    copy.appendChild(title);

    if (item.variant_title && item.variant_title !== 'Default Title') {
      var variant = document.createElement('p');
      variant.textContent = item.variant_title;
      copy.appendChild(variant);
    }

    appendText(quantity, 'Quantity: ');
    strong = document.createElement('strong');
    strong.textContent = String(item.quantity || 0);
    quantity.appendChild(strong);
    copy.appendChild(quantity);

    appendText(casePrice, 'Unit price: ');
    strong = document.createElement('strong');
    strong.textContent = money(item.final_price || item.price || 0);
    casePrice.appendChild(strong);
    copy.appendChild(casePrice);

    appendText(lineTotal, 'Line total: ');
    strong = document.createElement('strong');
    strong.textContent = money(item.final_line_price || item.line_price || 0);
    lineTotal.appendChild(strong);
    copy.appendChild(lineTotal);

    line.appendChild(media);
    line.appendChild(copy);
    return line;
  }

  function setActionsEnabled(hasItems) {
    [checkoutLink, viewCartLink].forEach(function (link) {
      if (!link) return;
      link.setAttribute('aria-disabled', hasItems ? 'false' : 'true');
      link.classList.toggle('is-disabled', !hasItems);
    });
  }

  function renderCart(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var hasItems = items.length > 0;

    if (emptyNode) emptyNode.hidden = hasItems;
    if (linesNode) {
      linesNode.hidden = !hasItems;
      linesNode.innerHTML = '';
      items.forEach(function (item) {
        linesNode.appendChild(renderLine(item));
      });
    }
    if (drawerCountNode && drawerCountNode.firstElementChild) {
      drawerCountNode.firstElementChild.textContent = (cart.item_count || 0) === 1 ? '1 item' : (cart.item_count || 0) + ' items';
    }
    if (subtotalNode) subtotalNode.textContent = money(cart.total_price);
    if (checkoutLink && config.checkoutUrl) checkoutLink.href = config.checkoutUrl;
    if (viewCartLink && config.cartUrl) viewCartLink.href = config.cartUrl;
    setActionsEnabled(hasItems);
  }

  function syncCart() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart refresh failed');
        return response.json();
      })
      .then(function (cart) {
        setCount(cart.item_count || 0);
        renderCart(cart);
        return cart;
      });
  }

  function handleFormSubmit(event) {
    var form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"], form.product-form')) return;
    var submitter = event.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitter && submitter.disabled) return;

    event.preventDefault();

    var formData = new FormData(form);
    setStatus('Adding item...', false);
    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () {
            return {};
          }).then(function (body) {
            throw new Error(body.description || body.message || 'Unable to add this item.');
          });
        }
        return response.json();
      })
      .then(function (item) {
        setStatus('Item added.', false);
        return syncCart().then(function () {
          openDrawer();
        });
      })
      .catch(function (error) {
        setStatus(error.message || 'Cart update failed. Opening cart fallback.', true);
        form.submit();
      })
      .finally(function () {
        if (submitter) {
          submitter.disabled = false;
          submitter.removeAttribute('aria-busy');
        }
      });
  }

  document.addEventListener('submit', handleFormSubmit);
  cartTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      setStatus('', false);
      syncCart().catch(function () {}).finally(openDrawer);
    });
  });
  overlay.addEventListener('click', closeDrawer);
  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });

  syncCart().catch(function () {});
})();
